import { createGtm } from '@gtm-support/vue-gtm'
import { defineNuxtPlugin, useRuntimeConfig } from 'nuxt/app'

export default defineNuxtPlugin((nuxtApp) => {
  const { googleTagManagerId } =
        useRuntimeConfig().public

  if (googleTagManagerId !== '') {
    nuxtApp.vueApp.use(
      createGtm({
        debug: import.meta.dev,
        defer: false, // better tracking
        enabled: !import.meta.dev,
        id: googleTagManagerId,
        loadScript: !import.meta.dev
        // this option is only needed for multiple environments.
        // queryParams: {
        //   gtm_auth: googleTagManagerAuth,
        //   gtm_preview: '',
        //   gtm_cookies_win: 'x'
        // }
      })
    )

    console.log('✔ GTM enabled')
  }
})
